import { type CityProfile } from '@core/city-profile/city-profile'

// the Lyon demo profile — the historical default, kept intact for future use
export const kLyonProfile: CityProfile = {
  id: 'lyon',
  displayName: 'Métropole Mobilité',
  brandLines: ['Métropole Mobilité'],
  center: [4.8357, 45.7640],
  zoom: 13.2,
  supervisionZoom: 12.5,
  locale: 'fr-fr',
  tz: 'Europe/Paris',
  currency: '€',
}
